export const setToken = (token: string) => {
	localStorage.setItem('wxtoken', token);
};

export const getToken = () => {
	return localStorage.getItem('wxtoken');
};
